'use strict'

export let english_releaseDetails={
  themes: {
    plan: {
      title: "Plan"
    }
  }
};



// WEBPACK FOOTER //
// ./views/product/labels/english#releaseDetails.js